import { Routes, Route } from "react-router-dom";
import Invoicing from "./Invoicing";

const index = () => {
	return (
		<Routes>
			<Route index element={<Invoicing />} />
		</Routes>
	);
};

export default index;
